module.exports = __webpack_public_path__ + "img/bg.5420ef7.png";